































import type { Ref } from '@vue/composition-api';
import { ref, defineComponent } from '@vue/composition-api';
import debounce from 'debounce';
import { IconSize } from '@getaccept/lib-ui';
import { TooltipPlacement } from '../enums/tooltip-placement';

export default defineComponent({
  name: 'SearchContent',
  props: {
    searching: { type: Boolean, default: false },
    placeholder: { type: String, required: true },
  },
  setup(_, { emit }) {
    const searchInput = ref('');
    const searchBoxRef: Ref<HTMLInputElement> = ref(null);

    const handleSearch = () => {
      emit('search', searchInput.value);
    };

    const handleClearInput = () => {
      emit('search', '');
      searchInput.value = '';
    };

    const debounceSearch = debounce(handleSearch, 200);

    const handleInput = (text: string) => {
      searchInput.value = text;
      debounceSearch();
    };

    return {
      handleClearInput,
      handleSearch,
      handleInput,
      searchInput,
      searchBoxRef,
      TooltipPlacement,
      IconSize,
    };
  },
});
